<template>
  <div>
    <label class="form-label">
      Conditions:
    </label>
    <div v-for="({ field, value }) in conditions" :key="field.id" class="d-flex flex-row align-items-center gap-1">
      <icon-button icon="trash" @click="field.removeCondition(field.id)" />
      <div>{{ field.label }}</div>
      <input type="text" class="form-control form-control-inline" :value="value" @input="v => field.setCondition(field.id, v)" />
    </div>
    <select v-model="fieldId" class="form-select form-control-inline">
      <option disabled :value="null">Add condition</option>
      <option v-for="field in form.fields" :key="field.id" :value="field.id">{{ field.label }}</option>
    </select>
  </div>
</template>

<script>
import FormField from "@/models/FormField";
import IconButton from "@/components/common/IconButton.vue";
import {LicenseApplicationForm} from "@/models/LicenseApplicationForm";

export default {
  components: {IconButton},
  props: {
    field: FormField,
    form: LicenseApplicationForm
  },
  computed: {
    fieldId: {
      get() {
        return null;
      },
      set(id) {
        this.field.addCondition(id);
      }
    },
    conditions() {
      let conditions = [];
      for (let fieldId in this.field.showIf) {
        let field = this.form.fields.find(field => field.id === fieldId);
        conditions.push({
          field,
          value: this.field.showIf[fieldId]
        });
      }
      return conditions;
    }
  }
}
</script>
